export default "__VITE_ASSET__ZEdZOUhY__"